export const regionCode = [
  { id: "1", name: "Jammu And Kashmir" },
  { id: "2", name: "Himachal Pradesh" },
  { id: "3", name: "Punjab" },
  { id: "4", name: "Chandigarh" },
  { id: "5", name: "Uttarakhand" },
  { id: "6", name: "Haryana" },
  { id: "7", name: "Delhi" },
  { id: "8", name: "Rajasthan" },
  { id: "9", name: "Uttar Pradesh" },
  { id: "10", name: "Bihar" },
  { id: "11", name: "Sikkim" },
  { id: "12", name: "Arunachal Pradesh" },
  { id: "13", name: "Nagaland" },
  { id: "14", name: "Manipur" },
  { id: "15", name: "Mizoram" },
  { id: "16", name: "Tripura" },
  { id: "17", name: "Meghalaya" },
  { id: "18", name: "Assam" },
  { id: "19", name: "West Bengal" },
  { id: "20", name: "Jharkhand" },
  { id: "21", name: "Odisha" },
  { id: "22", name: "Chhattisgarh" },
  { id: "23", name: "Madhya Pradesh" },
  { id: "24", name: "Gujarat" },
  { id: "25", name: "Daman And Diu (old)" },
  { id: "26", name: "Dadra & Nagar Haveli and Daman & Diu" },
  { id: "27", name: "Maharashtra" },
  { id: "28", name: "Andhra Pradesh (Old)" },
  { id: "29", name: "Karnataka" },
  { id: "30", name: "Goa" },
  { id: "31", name: "Lakshadweep" },
  { id: "32", name: "Kerala" },
  { id: "33", name: "Tamil Nadu" },
  { id: "34", name: "Puducherry" },
  { id: "35", name: "Andaman And Nicobar islands" },
  { id: "36", name: "Telangana" },
  { id: "37", name: "Andhra Pradesh" },
  { id: "38", name: "Ladakh" },
  { id: "97", name: "Other Territory" },
];